interface BadgeProps {
  label: string;
  tone?: "accent" | "secondary" | "primary";
  className?: string;
}

const toneMap: Record<string, string> = {
  accent: "bg-accent-500 text-foreground-950",
  secondary: "bg-secondary-500 text-foreground-50",
  primary: "bg-primary-500 text-foreground-50",
};

export default function Badge({ label, tone = "accent", className = "" }: BadgeProps) {
  return (
    <span
      className={`inline-flex items-center rounded-md px-2 py-0.5 text-[11px] font-medium leading-tight whitespace-nowrap ${toneMap[tone]} ${className}`}
    >
      {label}
    </span>
  );
}

export function tagTone(tag: string): "accent" | "secondary" | "primary" {
  if (tag === "新片" || tag === "热播" || tag === "奥斯卡") return "accent";
  if (tag === "高分") return "primary";
  return "secondary";
}